import { EndpointSetting } from "@/constants/app/type";
import { TourState } from "../types";
import { getValidDayjs } from "@/utils/safeParse/getValidDayjs";


export const callbackTourDetail: EndpointSetting['caller'] = (
  state: TourState,
  action: any,
  endpointName: any
) => {

  state.tour_details.loading = false
  state.tour_details.error = null
  state.tour_details.success = true
  state.tour_details.called = true
  state.tour_details.data = {
    ...action.payload,
    itinerary: [
      ...(action.payload.itinerary || []).map((i: any) => {
        return {
          ...i,
          images: i.images || [],
        }
      })
    ],
    departureSchedule: action.payload.departureSchedule
    .sort((a: any, b: any) => (getValidDayjs(a.startDate).valueOf() - getValidDayjs(b.startDate).valueOf()))
    .map((departureSchedule: any) => {
      return {
        ...departureSchedule,
        id: `${departureSchedule.tourId}_${departureSchedule.pricesId}`,
        flights: [departureSchedule?.ticketPlaneGo, departureSchedule?.ticketPlaneBack]
          .filter(str => !!str)
          .map((str: string, idx1) =>
            str?.split(" // ").map(
              (str, idx) => {
                const [flightNumber, startPoint, endPoint, startTime, , endTime] = str?.split(" ") || []
                return {
                  flightNumber,
                  startPoint: startPoint,
                  endPoint: endPoint,
                  startTime,
                  endTime,
                  airline: flightNumber.slice(0, 2),
                  date: idx1 === 0
                    ? getValidDayjs(departureSchedule?.startDate).format("DD-MM-YYYY")
                    : getValidDayjs(departureSchedule?.endDate).format("DD-MM-YYYY")
                }
              }
            )
          )
      }
    })
  }
}